<template>
  <div>
    <span class="trace tSmaller">components/ProjectCard.vue {{ idx }} {{ graphic }}</span>

    <!--
      forward all event listeners on the component to a specific child element with v-on="$listeners"
      to: below is router directives
        params: { project: 'lorem-ipsum21', graph: graphic },
      :to="{
        name: 'Project',
        params: { project: graphic, graph: graphic },
        graph: graphic,
      }"

      :to has the effect of a router push to the name
      name: 'Project',
      params: { project: graphic, graph: graphic },

      :to="{
        name: 'Project',
        params: { project: graphic, graph: graphic },
      }"

    -->
    <base-card

      class="mx-3"
      v-bind="$attrs"
      :title="projectTitle"
      v-on="$listeners"
    >
      <!--
      |{{ projectTitle }}| |{{ graphic }}|

      <span class="trace"><br>{{ src }}</span>
        :src="src"
        :src="require(`@/assets/project-${idx + 1}.jpg`)"

      -->
      <base-img
        v-if="graphic"
        :aspect-ratio="1.4"
        :src="require(`@/assets/project-${graphic}.jpg`)"
        height="inherit"
        dark
        another-attr
        @click="sayMe('click')"
      />
    </base-card>
  </div>
</template>

<script>
  export default {
    name: 'ProjectCard',

    props: {
      src: String,
      idx: Number,
      graphic: String,
      // projectTitle: String,
      projectTitle: {
        type: String,
        default: 'Need Title',
      },
    },

    methods: {
      sayMe: function (arg) {
        console.log(arg)
        // alert('ProjectCard.vue:' + this.graphic)
      },
    },

  }
</script>
